import './styles/HeaderGallery.css';

export default function OnBoardingButton({ selectedTheme, state }) {
  
  return (        
    <>
      <h2 className={`onboarding-theme__h2 ${!selectedTheme ? "not-theme" : ""}`}>Welcome {state.user_session.user_name}!</h2>
      <div className={`onboarding-theme__username ${!selectedTheme ? "not-theme" : ""}`}>
        <p className="onboarding-theme__user_message">Thank you for successfully uploading your first artworks! You can now explore and enjoy your profile.</p>
      </div>
    </>);
}